// One readable sentence from a failed call, for inline form errors: the problem's detail, else
// its field errors (`path: message`, as the API's 422 `validation_failed` lists them), else its
// title.
import { ApiError } from "@companyos/sdk";

export function problemText(error: unknown, fallback: string): string {
  if (error instanceof ApiError) {
    const p = error.problem;
    if (p?.detail) return p.detail;
    if (p?.errors?.length) return p.errors.map((e) => `${e.path}: ${e.message}`).join("; ");
    return p?.title ?? fallback;
  }
  return error instanceof Error ? error.message : fallback;
}
